import React from 'react'

const Footer = function footer ({info}){
    return (
        <footer>
            <div className="container colflex w90">
            <div className="links flex">
                <a className="logow flex">
                <img src={https+"img/logo.svg"} alt="bodubri"/>
                </a>
                <div className="navigate flex">
                <a href={https}>Inicio</a>
                <a href={https+"shop"}>Productos</a>
                <a href={https+"contact"}>Contáctanos</a>
                </div>
                <div className="social flex">
                <a target="_blank" href={info.facebook} className="flex">
                    <img src={https+"img/facebookic.svg"} alt="facebook"/>
                </a>
                <a target="_blank" href={info.youtube} className="flex">
                    <img src={https+"img/youtubeic.svg"} alt="youtube"/>
                </a>
                <a target="_blank" href={info.instagram} className="flex">
                    <img src={https+"img/instagramic.svg"} alt="instagram"/>
                </a>
                </div>
            </div>
            <div className="info flex">
                <a href={"tel:"+info.cellphone} className="cellphone flex">
                <img src={https+"img/cellphone.svg"} alt="📱"/>
                <span>{info.cellphone}</span>
                </a>
                <a href={"mailto:"+info.mail} className="mail flex">
                <img src={https+"img/envelope.svg"} alt="📩"/>
                <span>{info.mail}</span>
                </a>
                <a target="_blank" href={"https://www.google.com/maps/place/MONSTER+CAR+AUDIO/@"+info.latitud+","+info.longitud+",17z/data=!3m1!4b1!4m5!3m4!1s0x8ef42d5c62b8c65d:0xb468e689d3cf309e!8m2!3d10.9965078!4d-74.8071029"} className="locate flex">
                <img src={https+"img/marker.svg"} alt="🗺"/>
                <p>{info.address}<br/>{info.city}</p>
                </a>
            </div>
            </div>
            <div className="gtnd flex">
            <p>©2021 Monster Car Audio. Todos los derechos reservados.</p>
            <div className="flex">
                <p>Creado por </p>
                <a target="_blank" href="https://www.gutand.com/">
                <img src={https+"img/marca-gutand.svg"} alt="gutand"/>
                </a>
            </div>
            </div>
        </footer>
)
}

export default Footer